module.exports = __webpack_public_path__ + "img/003_thumbnail.00678b24.jpg";